import { render, staticRenderFns } from "./ProductTransfer.vue?vue&type=template&id=5410dbb4&scoped=true"
import script from "./ProductTransfer.vue?vue&type=script&lang=js"
export * from "./ProductTransfer.vue?vue&type=script&lang=js"
import style0 from "./ProductTransfer.vue?vue&type=style&index=0&id=5410dbb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5410dbb4",
  null
  
)

export default component.exports